import React, { useState } from 'react';
import './Header.css';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="header">
      <div className="container">
        <div className="nav-brand">
          <img src="/assets/images/logo.png" alt="Physero" className="logo" />
        </div>
        <nav className={`nav ${isMenuOpen ? 'nav-open' : ''}`}>
          <ul className="nav-links">
            <li><a href="#services">Services</a></li>
            <li><a href="#physiotherapists">Our Team</a></li>
            <li><a href="#testimonials">Testimonials</a></li>
            <li><a href="#booking">Contact</a></li>
          </ul>
        </nav>
        <div className="header-actions">
          {/* <button className="btn-secondary">Book Lab Test</button> */}
          <button
            className="btn-primary"
            onClick={() => {
              const bookingSection = document.getElementById('booking');
              if (bookingSection) {
                bookingSection.scrollIntoView({ behavior: 'smooth' });
              }
            }}
          >
            Schedule Session
          </button>
        </div>
        <div className="mobile-menu-toggle" onClick={() => setIsMenuOpen(!isMenuOpen)}>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </header>
  );
};

export default Header;